"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const Caret = () => (0, jsx_runtime_1.jsx)("span", { className: 'caret' });
exports.default = Caret;
